import {
    AuditOutlined,
    CloudServerOutlined,
    AppstoreOutlined,
    ApiOutlined,
    PicLeftOutlined,
    UserOutlined,
    GithubFilled,
    BugOutlined
} from '@ant-design/icons';
import { Menu } from 'antd';
import React, {useEffect, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import classes from './Menu.module.css';
import MachineIcon from "../CustomIcons/MachineIcon";
import ProjectIcon from "../CustomIcons/ProjectIcon";
import StaffIcon from "../CustomIcons/StaffIcon";
import SettingsIcon from "../CustomIcons/SettingsIcon";
import BranchIcon from "../CustomIcons/BranchIcon";
import PartnerIcon from "../CustomIcons/PartnerIcon";
import ConstructorIcon from "../CustomIcons/ConstructorIcon";
import {useTranslation} from "react-i18next";
import {useData} from "../../DataContext";
import PermissionChecker from "../../PermissionChecker";

// const { SubMenu } = Menu;

// submenu keys of first level
const pathNameKeyMapper = {
    '': 'profile',
    '/': 'profile',
    '/user/profile': 'profile',
    '/users': 'user',
    '/user/detail': 'user',
    '/branches': 'branch-settings',
    '/settings': 'general-settings',
    '/partners': 'partners',
    '/partner/detail': 'partners',
    '/constructors': 'constructors',
    '/constructor/detail': 'constructors',
    '/user_permissions': 'user-permissions',
    '/system_infos': 'system-infos',
    '/auth_apps': 'auth-apps',
    '/api_servers': 'api-servers',
    '/api_events': 'api-events',
    '/api_tasks': 'api-tasks',
    '/cloud_services': 'cloud-services',
    '/cloud_services/detail': 'cloud-services',
}
const getAdminMenu = (props, t) => {
    return [
        <Menu.Item key="profile" icon={<UserOutlined style={{color: "#377EF3"}}/>} className={classes.menuItemStyle}>
            <Link to='/user/profile'>{t('menu_0')}</Link>
        </Menu.Item>,
        <Menu.Item key="cloud-services" icon={<AppstoreOutlined style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/cloud_services'>{t('menu_3')}</Link>
        </Menu.Item>,
        <Menu.Item key="partners" icon={<PartnerIcon/>} className={classes.menuItemStyle}>
            <Link to='/partners'>{t('menu_1')}</Link>
        </Menu.Item>,
        <Menu.Item key="constructors" icon={<ConstructorIcon/>} className={classes.menuItemStyle}>
            <Link to='/constructors'>{t('menu_2')}</Link>
        </Menu.Item>,
        <Menu.Item key="user" icon={<StaffIcon/>} className={classes.menuItemStyle}>
            <Link to='/users'>{t('menu_4')}</Link>
        </Menu.Item>,
        <Menu.Item key="branch-settings"  icon={<BranchIcon />} className={classes.menuItemStyle}>
            <Link to='/branches'>{t('menu_5')}</Link>
        </Menu.Item>,
        <Menu.Item key="general-settings" icon={<SettingsIcon />} className={classes.menuItemStyle}>
            <Link to='#'>{t('menu_6')}</Link>
        </Menu.Item>,
    ];
}

const systemUserMenu = (props, t) => {
    return [
        <Menu.Item key="user-permissions" icon={<AuditOutlined/>} className={classes.menuItemStyle}>
            <Link to='/user_permissions'>User Permissions</Link>
        </Menu.Item>,
        <Menu.Item key="auth-apps" icon={<AppstoreOutlined style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/auth_apps'>Auth Apps</Link>
        </Menu.Item>,
        <Menu.Item key="api-servers" icon={<CloudServerOutlined style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/api_servers'>API Servers</Link>
        </Menu.Item>,
        <Menu.Item key="api-events" icon={<ApiOutlined style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/api_events'>API Events</Link>
        </Menu.Item>,
        <Menu.Item key="api-tasks" icon={<PicLeftOutlined style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/api_tasks'>API Tasks</Link>
        </Menu.Item>,
        <Menu.Item key="error-logs" icon={<BugOutlined style={{color: '#377EF3'}}/>} className={classes
            .menuItemStyle}>
            <Link to='/error_logs'>Error Logs</Link>
        </Menu.Item>,
        <Menu.Item key="system-infos" icon={<GithubFilled style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/system_infos'>System Infos</Link>
        </Menu.Item>,
    ];
}

const getUserMenu = (props, t) => {
    return [
        <PermissionChecker key="profile" requiredPermissions={['user-detail']}>
            <Menu.Item key="profile" icon={<UserOutlined style={{color: "#377EF3"}}/>} className={classes.menuItemStyle}>
                <Link to='/user/profile'>{t('menu_0')}</Link>
            </Menu.Item>
        </PermissionChecker>,
        <PermissionChecker key="partners" requiredPermissions={['partner-list']}>
            <Menu.Item key="partners" icon={<PartnerIcon/>} className={classes.menuItemStyle}>
                <Link to='/partners'>{t('menu_1')}</Link>
            </Menu.Item>
        </PermissionChecker>,
        <PermissionChecker key="constructors" requiredPermissions={['constructor-list']}>
            <Menu.Item key="constructors" icon={<ConstructorIcon/>} className={classes.menuItemStyle}>
                <Link to='/constructors'>{t('menu_2')}</Link>
            </Menu.Item>
        </PermissionChecker>,
    ];
}

function buildMenu(props, auth, t) {
    if(auth.is_superuser){
        return systemUserMenu(props, t)
    }
    else if( auth.is_admin){
        return getAdminMenu(props, t);
    }
    else {
        return getUserMenu(props, t);
    }
}
const deriveMenuKey = (pathname) => {
    // Remove trailing slash if present
    const cleanedPath = pathname.replace(/\/$/, '');
    return pathNameKeyMapper[cleanedPath] || 'profile';
};


export const SiderMenu = ({props}) => {
    const {sharedData} = useData();
    const is_superuser = parseInt(sharedData.is_superuser||"0") || parseInt(window.sessionStorage.getItem('isSuperuser')||"0") || null;
    const is_adminuser = parseInt(sharedData.is_admin||"0") || parseInt(window.sessionStorage.getItem('isAdminUser')||"0") || null;
    const auth = {is_superuser: is_superuser, is_admin:is_adminuser}
    const { t } = useTranslation();
    let location = useLocation();
    const currentPath = deriveMenuKey(location.pathname);
    const [current, setCurrent] = useState(currentPath);

    useEffect(() => {
        if (current !== currentPath) {
            setCurrent(currentPath);
        }
    }, [location.pathname, currentPath, current]);

    const menus = buildMenu(props, auth, t);

    const handleMenuClick=(e)=>{
        setCurrent(e.key)
    }

    return (
        <Menu mode="inline" onClick={handleMenuClick} selectedKeys={[current]} className={classes.menu}>
            {menus}
        </Menu>
    );
};
